export const GaugeColor = {
  100: '#75C57F',
  85: '#EA973D',
  70: '#F6CF7D',
  50: '#D76B66',
};

export const getGaugeColor = (score: number) => {
  if (score >= 85) {
    return GaugeColor[100];
  }
  if (score >= 70) {
    return GaugeColor[85];
  }
  if (score >= 50) {
    return GaugeColor[70];
  }
  return GaugeColor[50];
};

export const getVisiblyCorrectValue = (value: number) => {
  return Math.max(value - 3, 0);
};

export const getScoreText = (score: number) => {
  if (score >= 85) {
    return 'מצוין ';
  }
  if (score >= 70) {
    return 'טוב מאוד ';
  }
  if (score >= 50) {
    return 'סביר ';
  }
  return 'מסוכן ';
};
export const getScoreTextSmiley = (score: number) => {
  let smileyCode;
  if (score >= 85) {
    smileyCode = '128578';
  } else if (score >= 70) {
    smileyCode = '128528';
  } else if (score >= 50) {
    smileyCode = '128528';
  } else {
    smileyCode = '128543';
  }
  return String.fromCodePoint(parseInt(smileyCode, 10));
};

export const getViolationsText = (violatingCount: number) => {
  if (!violatingCount) return 'לא נמצאו חשבוניות חשודות';

  return `נמצאו ${violatingCount} חשבוניות חשודות`;
};
